
export interface ITemplate {
    id: number,
    name: string,
    notes: number,
    featuredNoteIndex: number,
}

export const Templates : ITemplate[] = [
     {
        id: 1,
        name : "Barra lateral izquierda con nota a la derecha",
        notes: 5,
        featuredNoteIndex: 4,
    },
     {
        id: 2,
        name : "Dos barras laterales con nota centrada",
        notes: 8,
        featuredNoteIndex: 3,
    },
    {
        id: 3,
        name : "Sin barras laterales, nota centrada y notas en la parte inferior",
        notes: 4,
        featuredNoteIndex: 0,
    },
    {
        id: 4,
        name : "Barra lateral derecha con nota a la izquierda",
        notes: 4,
        featuredNoteIndex: 0,
    },
     {
        id: 5,
        name : "Barra lateral derecha grande",
        notes: 3,
        featuredNoteIndex: 2,
    }
]